// extracted by mini-css-extract-plugin
export var editButton = "_n7-0";